import Swiper, { Navigation, Pagination } from "swiper";
import { parseDataset } from "../lib/utilities";

window.addEventListener("load", () => {
   Swiper.use([Navigation, Pagination]);

   Array.from(document.querySelectorAll(".swiper")).forEach(element => {
      const datasetOptions = parseDataset(element.attributes);
      const defaultOptions = {
         speed: 800,
         pagination: {
            el: '.swiper-pagination',
         },
         navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
         },
      };

      const instance = new Swiper(element, { ...defaultOptions, ...datasetOptions });
   });
});
